import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "hooks/useAuth";
import { Menu, X } from "lucide-react";

const navItems = [
  { label: "Product", href: "/#product" },
  { label: "Features", to: "/features" },
  { label: "Pricing", to: "/pricing" },
  { label: "Resources", to: "/resources" },
];

const Navbar = () => {
  const { session, signOut } = useAuth();
  const user = session?.user;
  const [menuOpen, setMenuOpen] = useState(false);

  const closeMenu = () => setMenuOpen(false);

  const renderNavItem = (item, className = "") =>
    item.to ? (
      <Link key={item.label} to={item.to} onClick={closeMenu} className={className}>
        {item.label}
      </Link>
    ) : (
      <a key={item.label} href={item.href} onClick={closeMenu} className={className}>
        {item.label}
      </a>
    );

  return (
    <div className="fixed top-0 left-0 right-0 z-50 px-3 py-2 md:p-6 lg:p-8">
      <nav className="max-w-7xl mx-auto bg-white/95 backdrop-blur-xl border border-gray-100 rounded-3xl shadow-lg">
        <div className="px-4 py-3 flex justify-between items-center sm:px-6">
          <div className="flex items-center gap-4 md:gap-8">
            <Link
              to="/"
              className="text-xl font-extrabold bg-gradient-to-r from-pink-500 to-orange-400 bg-clip-text text-transparent"
            >
              TestimonialsHub
            </Link>

            <div className="hidden md:flex items-center gap-6 text-sm lg:text-base">
              {navItems.map((item) =>
                renderNavItem(
                  item,
                  "text-gray-700 hover:text-pink-500 font-medium transition"
                )
              )}

              {user && (
                <Link
                  to="/dashboard"
                  className="text-gray-700 hover:text-pink-500 font-medium transition"
                >
                  Dashboard
                </Link>
              )}
            </div>
          </div>

          <div className="flex items-center gap-2 sm:gap-4">
            {user ? (
              <button
                onClick={signOut}
                className="hidden md:block px-4 py-1.5 rounded-xl bg-gray-200 text-red-600 font-semibold shadow-md hover:bg-gray-300 text-sm transition"
              >
                Sign Out
              </button>
            ) : (
              <>
                <Link
                  to="/login"
                  className="hidden md:block text-gray-700 hover:text-pink-500 text-sm font-medium transition"
                >
                  Sign In
                </Link>

                <Link
                  to="/signup"
                  className="hidden md:block px-4 py-1.5 rounded-xl bg-gradient-to-r from-pink-500 to-orange-400 text-white font-semibold shadow-md hover:opacity-90 text-sm"
                >
                  Get Started Free
                </Link>
              </>
            )}

            <button
              type="button"
              aria-label="Toggle navigation menu"
              className="p-1 text-gray-700 hover:text-pink-500 transition md:hidden"
              onClick={() => setMenuOpen((open) => !open)}
            >
              {menuOpen ? <X size={26} /> : <Menu size={26} />}
            </button>
          </div>
        </div>
      </nav>

      {menuOpen && (
        <div className="md:hidden bg-white border border-gray-100 rounded-2xl mx-auto mt-2 shadow-md max-w-7xl">
          <div className="px-6 py-6 space-y-4">
            {navItems.map((item) =>
              renderNavItem(item, "block font-medium text-gray-800")
            )}

            {user ? (
              <div className="border-t pt-4">
                <Link
                  to="/dashboard"
                  onClick={closeMenu}
                  className="block font-medium text-blue-600"
                >
                  Dashboard
                </Link>
                <button
                  type="button"
                  onClick={signOut}
                  className="w-full text-left py-2 text-red-600 font-semibold mt-2"
                >
                  Sign Out
                </button>
              </div>
            ) : (
              <div className="pt-4 flex flex-col gap-3 border-t">
                <Link
                  to="/login"
                  className="py-2 text-center border rounded-xl"
                  onClick={closeMenu}
                >
                  Login
                </Link>
                <Link
                  to="/signup"
                  className="py-2 text-center rounded-xl bg-gradient-to-r from-pink-500 to-orange-400 text-white font-semibold"
                  onClick={closeMenu}
                >
                  Get Started Free
                </Link>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default Navbar;
